import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {catchError, map} from 'rxjs/operators';

import {addLocation, getDetailPointOfAction, getMapData, removeLocation} from '../variables';
import {AuthService} from '../auth/auth.service';
import {PointOfActionModel} from "../../models/map/point-of-action.model";
import {toMapMarkerModel} from "../../models/map/map-marker/map-marker.mapper";
import {MapMarkerModel} from "../../models/map/map-marker/map-marker.model";

@Injectable({
  providedIn: 'root'
})
export class GetMapApiService {
  constructor(
    private http: HttpClient,
    private auth: AuthService
  ) {
  }

  getMapMarkers(type?: 'organization' | 'space', id?: number): Observable<MapMarkerModel[]> {
    let url = getMapData;

    if (type && id) {
      url += `?type=${type}&id=${id}`;
    }

    return this.http.get<{ data: any[] }>(
      url,
      { headers: this.auth.multiPartHeader }
    ).pipe(
      map(res => res.data.map(toMapMarkerModel)),
      catchError((err) => {
        console.error('API error (getMapMarkers):', err);
        return throwError(() => err);
      })
    );
  }

  addLocation(payload: any): Observable<any> {
    return this.http.post<any>(
      addLocation,
      payload,
      {headers: this.auth.multiPartHeader}
    ).pipe(
      catchError((err) => {
        console.error('API error:', err);
        return throwError(() => err);
      })
    );
  }

  removeLocation(payload: any): Observable<any> {
    return this.http.post<any>(
      removeLocation,
      payload,
      {headers: this.auth.multiPartHeader}
    ).pipe(
      catchError((err) => {
        console.error('API error:', err);
        return throwError(() => err);
      })
    );
  }

  getPointOfActionDetail(id: number): Observable<PointOfActionModel> {
    return this.http.get<PointOfActionModel>(
      `${getDetailPointOfAction}/${id}`,
      {headers: this.auth.multiPartHeader}
    ).pipe(
      catchError((err) => {
        console.error('API error (getPointOfActionDetail):', err);
        return throwError(() => err);
      })
    );
  }
}
